
export namespace ConfirmDialogModel {
  export enum ConfirmResult {
    CANCEL,
    OK,
  }

  export enum ConfirmDialogType {
    INFO,
    WARN,
    CONFIRM,
  }

  export interface ConfirmDialogOptions {
    disableClose?: boolean;
    type: ConfirmDialogType;
    title: string;
    msg: string;
    description?: string;
    confirm?: string;
    cancel?: string;
    hideCancel?: boolean;
    action?: () => void;
    cancelAction?: () => void;
    returnOnClose?: ConfirmResult;
    params?: Record<string, unknown>;
  }

  export interface ConfirmDialogResult {
    selection: ConfirmDialogModel.ConfirmResult;
    type: ConfirmDialogModel.ConfirmDialogType;
  }

  // Confirm name modal options
  export interface Options {
    title: string;
    wordToConfirm: string;
    disableClose?: boolean;
    description?: string;
    confirmLabel?: string;
    cancelLabel?: string;
    hideCancel?: boolean;
    action?: () => void;
    cancelAction?: () => void;
    params?: Record<string, unknown>;
  }


  export enum Action {
    deleteEdge,
    restartEdge,
    removeEvent,
    searchConfigurationDelete,
    resetCameraAddress,
    removeInvitedOrg,
    removeJob,
    unprovisionEdge,
    deleteEdgeUnit,
    removeUserFromPermission,
    removeOrgFromPermission,
    playbackShutDown,
    cleanPlaybacks,
    deleteStrategy,
    updateStrategy,
    removeSpeaker,
    removeLocation,
    updateNetworkProfile,
    removeExternalStorage,
    deleteSensor,
    revokeOauthProvider,
    removeRemoteIo,
    deleteMicrosoftTeams,
    deleteHttpRequestKey,
    removeDatabaseTag,
    resetEdgeAddress,
    resetDeviceAddress,
    removeShelf,
    removeMapObject,
    deleteAccount,
    deletePartition,
    deleteAccountContact,
    deleteAccountGroup,
    navigateToAccountList,
    removeOrganizationContact,
    deleteGrantedOrganisation,
    removeVacationPeriod,
    removeZoneRegion,
    removeWorkflow,
    removeWorkflowWebhook,
    removeCaseCategory,
    deletePolicy,
    deleteAnnotationComment,
    deleteCaseAnnotation,
    deleteCaseComment,
    deleteCaseClip,
    deleteCase,
    resetRemaining,
    navigateToTag,
    switchCaseOrganization,
    deleteWall,
    deletePrivateStorage,
    setDefaultPrivateStorage,
    clearDefaultPrivateStorage,
    deleteSop,
    cancelOrganizationDeletion,
    pauseOrganizationDeletion,
    resumeOrganizationDeletion,
    clearAdvancedAnalyticsJobsHistory,
    saveSingleNtpServer,
  }
}
